import { MediaStats, PostScores } from '../../MediaStats';

interface Stats {
  isPublished: boolean;
  commentsCount: number;
  scores?: PostScores;
}

const Meta = ({ commentsCount, isPublished, scores }: Stats): JSX.Element => (
  <div className="ml-1 inline-flex items-center justify-between gap-2 text-sm">
    {isPublished ? <MediaStats comments={commentsCount} scores={scores} /> : <p>Не опубл.</p>}
  </div>
);

export { Meta };
export type { Stats };
